import { defineMessages } from "react-intl";

/**
 * COM-735 — fixed UI strings of the Contact Us form. Labels are the live
 * content-asset labels; the form uppercases them at the call site (SFRA does it
 * in CSS — `text-transform: uppercase`, Grotesque 14px/500).
 */
const messages = defineMessages({
  nameLabel: { id: "contactUs.form.name_label", defaultMessage: "Name" },
  emailLabel: { id: "contactUs.form.email_label", defaultMessage: "Email" },
  subjectLabel: {
    id: "contactUs.form.subject_label",
    defaultMessage: "Subject",
  },
  subjectPlaceholder: {
    id: "contactUs.form.subject_placeholder",
    defaultMessage: "Please Select",
  },
  orderNumberLabel: {
    id: "contactUs.form.order_number_label",
    defaultMessage: "Order Number",
  },
  descriptionLabel: {
    id: "contactUs.form.description_label",
    defaultMessage: "Description",
  },
  rateLimited: {
    id: "contactUs.form.rate_limited",
    defaultMessage: "Too many attempts. Please try again in a few minutes.",
  },
});

export default messages;
